import { endOfToday, subMonths } from 'date-fns';
import { TABLES } from 'enums/tables';

export const PAGE_SIZES = TABLES.PAGE_SIZES.MD;

// ! can be deprecated if we switch over to customer API format via postgres for export shots
export const MIN_DATE = subMonths(endOfToday(), 6);
export const MAX_DATE = endOfToday();
